import { ThemeProvider } from "@mui/material";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import React from "react";
import ReactDOM from "react-dom/client";
import { useTranslation } from "react-i18next";

import App from "./App";
import keycloak from "./keycloak-config";
import ledgerTheme, { ledgerThemeDe } from "./styles/LedgerTheme";
import "@repo/legacy/styles/main.css";

const ThemedApp = ({ host }: { host: string }) => {
	const { i18n } = useTranslation();
	const theme = i18n.language === "de" ? ledgerThemeDe : ledgerTheme;

	return (
		<ThemeProvider theme={theme}>
			<App host={host} />
		</ThemeProvider>
	);
};

const host = import.meta.env.VITE_API_HOST;

const keycloakConfig = {
	onLoad: "login-required",
	checkLoginIframe: false,
};

const enableTheming = true;

const root = document.getElementById("root");
if (!root) throw new Error("No root element");

ReactDOM.createRoot(root).render(
	<ReactKeycloakProvider authClient={keycloak} initOptions={keycloakConfig}>
		<React.StrictMode>
			{enableTheming ? <ThemedApp host={host} /> : <App host={host} />}
		</React.StrictMode>
	</ReactKeycloakProvider>,
);
